/**
 * Resolve Ant Design Menu state from the current application pathname.
 * Menu paths are stored without the `/page` route prefix.
 */
export function getMenuSelection(pathname = "", menus = []) {
  const currentPath = pathname.replace(/^\/page(?=\/|$)/, "") || "/";
  let selected = null;

  const visit = (items, parents = []) => {
    items.forEach((item) => {
      const path = item.path || "";
      const matches = path && (currentPath === path || currentPath.startsWith(`${path}/`));
      if (matches && (!selected || path.length > selected.path.length)) {
        selected = { key: item.code, path, parents };
      }
      if (Array.isArray(item.subMenus)) {
        visit(item.subMenus, [...parents, item.code]);
      }
    });
  };

  visit(menus);
  return selected
    ? { selectedKeys: [selected.key], openKeys: selected.parents }
    : { selectedKeys: [], openKeys: [] };
}
